module.exports = __webpack_public_path__ + "img/3_2_1.2d9285bf.jpg";